import { Link } from 'react-router-dom';
import diplomadoDocencia from '../../assets/img/cursos/diplo/diplomado-docencia-universitaria.jpeg';
import './Diplomados.css';

const Diplomados = () => (
  <main className="oferta-academica-page diplomados-page">
    <section className="diplomados-hero" aria-labelledby="diplomados-titulo">
      <p className="oferta-eyebrow">Oferta académica</p>
      <h1 id="diplomados-titulo">Diplomados Habilitados</h1>
      <span className="oferta-accent" aria-hidden="true" />
    </section>

    <section className="diplomado-listado" aria-label="Diplomados habilitados">
      <article className="diplomado-listado-card">
        <div className="diplomado-listado-imagen">
          <img src={diplomadoDocencia} alt="Docencia Universitaria" loading="lazy" decoding="async" />
        </div>
        <div className="diplomado-listado-info">
          <p className="oferta-eyebrow">Diplomado</p>
          <h2>Docencia Universitaria</h2>
          <p className="diplomado-listado-enfasis">Con énfasis en Educación Inclusiva</p>
          <p className="diplomado-listado-resumen">
            Este diplomado te permitirá desarrollar habilidades pedagógicas avanzadas, metodologías de enseñanza innovadoras y técnicas de evaluación efectivas para mejorar tu desempeño como docente universitario.
          </p>
          <div className="diplomado-listado-datos" aria-label="Características del diplomado">
            <span>6 módulos</span>
            <span>Clases presenciales</span>
          </div>
          <Link className="oferta-primary-button" to="/diplomados/docencia-universitaria">
            Ver Programa <span aria-hidden="true">↗</span>
          </Link>
        </div>
      </article>
    </section>
  </main>
);

export default Diplomados;
